<template>
    <div class="case">
        <div class="case-container">
            <h1>/ lesenphants /</h1>
            <p class="case-intro">An freelance project with the largest retailer of children’s wear and accessories in Taiwan.</p>
            <img src="../../assets/case2-1.png" alt="" class="align-paragraph">
            <p>This is an web-based app which link with a instant message service, LINE, the most popular IM service in Taiwan.</p>
            <p>By linking with LINE, Lesenphants expect to increase the online member's usage, and help user to find children's product, also the mothering classroom activity that Lesenphants held in their store.</p>
            <img src="../../assets/case2-2.jpg" class="wide" alt="">
            <p>Here is the Figma prototypes:</p>
            <div class="figma">
                <iframe style="border: none;" height="450" src="https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Fproto%2FJZfYWOvu5FCk7HkUhkNGEb%2F%25E9%25BA%2597%25E5%25AC%25B0%25E6%2588%25BF%3Fnode-id%3D68%253A105%26viewport%3D240%252C341%252C0.06829006224870682%26scaling%3Dscale-down" allowfullscreen></iframe>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            test:'test'
        }
    }
    
}
</script>
<style lang="scss" scoped>
    
</style>